import * as React from 'react';
import { Header, Icon, Segment, Modal, Button } from 'semantic-ui-react';
import { ActionModalContentProps } from '../interfaces/ActionModalProps';

const InquiryModal = (props: ActionModalContentProps) => (
  <Modal
    basic
    size='tiny'
    closeIcon
    onClose={props.onCloseModal}
    open={props.actionModalForm.open}
  >
    <Modal.Header>
    Confirm Request Contact
    </Modal.Header>
    <Modal.Content>
      <Modal.Description>
        Are you sure you wish to request the member contact you about this transaction?
      </Modal.Description>
      <Modal.Description>
        This will transaction will continue to be in a pending state.
        </Modal.Description>
      {props.transactionFormTouched &&
        <Modal.Description>
          <strong>Change made to the transaction form will <i>not</i> be saved.</strong>
        </Modal.Description>
      }
    </Modal.Content>
    <Modal.Actions>
      <Button
        color='grey'
        labelPosition='right'
        icon='undo'
        content='Close'
        inverted
        size='tiny'
        onClick={props.onCloseModal}
      />
      <Button
        color='olive'
        labelPosition='right'
        icon='question circle'
        content='Request Contact'
        inverted
        size='tiny'
        onClick={props.onConfirm}
      />
    </Modal.Actions>
  </Modal>
)

export default InquiryModal